module.exports = __webpack_public_path__ + "img/iboshow.52738581.jpg";